<template>
    <div class='dv5-header'>
        <div class="dv5-header-title-content">
            <div class="dv5-header-title">
                {{view.translation.office2_autopilot_menu_dashboard}}&nbsp;<img v-if="view['is_vip']" class="img-top" src="/internacional/public/office5/img/general-svg/icon_vip.svg" />
            </div>
            <div class="dv5-header-subtitle" >{{view.translation.label_welcome}}&nbsp;<span>{{firstAndLastName}}</span>&nbsp;<img v-if="view['is_vip']" class="img-end" src="/internacional/public/office5/img/general-svg/icon_vip.svg" /></div>
        </div>
        <div v-if="view.allow_buy_domain" v-show="view.father_is_builderall" class="dv5-header-button-content">
            <a v-show="this.view.show_wpp_buyer" class="wpp-group" :href="getWhatsappBuyersGroupLink" target="_blank">
                <img :src="`/internacional/public/office5/img/general-svg/wpp.svg`">
                <span>{{ view.translation.label_buyer_wpp }}</span>
            </a>
            <connect-domain :view="view" />
            <dv5-buy-domain :view="view"/>
        </div>
    </div>
</template>


<script>

export default {
    name: "dv5-header",
    props: {
        view: {
            type: Object,
            default: function () {
               return {
                    title: 'Dashboard',
                    userName: 'Nome da pessoa',
                    welcome: 'Welcome'
                };
            }
        }
    },
    data() {
        return {};
    },

    created() {
    },

    mounted() {
    },

    methods: {
    },

    computed: {
        firstAndLastName(){
            let aux = '';
            if(this.view !== undefined && this.view !== null && this.view.userName !== undefined && this.view.userName !== null) {
                let name = this.view.userName;

                /**
                 * Change "John Nick (Marketing)" to "John Nick"
                 *  (space) matches the character   (space) literally
                 *  \( matches the character ( literally
                 *  [\s\S] matches any character (\s matches any whitespace character and \S matches any non-whitespace character)
                 *  *? matches between zero and unlimited times
                 *  \) matches the character ) literally
                 *  g matches globally
                 */
                if(name.includes('(')){
                    name = name.replace(/ \([\s\S]*?\)/g, '');
                }

                let arr = name.split(' ');
                if(arr !== undefined && arr !== null && arr.length > 0) {
                    if(arr[0] !== undefined && arr[0] !== null) {
                        aux += arr[0];
                    }
                    let len = arr.length;
                    if(len > 1 && arr[len-1] !== undefined && arr[len-1] !== null) {
                        aux += ' '+arr[len-1];
                    }
                }
            }
            return aux;
        },
        getWhatsappBuyersGroupLink() {
            switch (this.view.lang) {
                case 'us':
                    return 'https://wppg.builderall.com/api/c/80'
                    break;
                case 'br':
                    return 'https://wppg.builderall.com/api/c/81'
                    break;
                case 'de':
                    return 'https://wppg.builderall.com/api/c/82'
                    break;
                case 'es':
                    return 'https://wppg.builderall.com/api/c/83'
                    break;
                case 'it':
                    return 'https://wppg.builderall.com/api/c/78'
                    break;
                default:
                    return 'https://wppg.builderall.com/api/c/80'
                    break;
            }
        }
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import '../../../scss/extras/_variables';
    .dv5-header{
        padding: 1em 6em 1em 6em;
        width: 100%;
        display: flex;
        align-items: center;
        column-gap: 5px;
        .dv5-header-title-content {
            font: inherit;
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            column-gap: 5px;

            .dv5-header-title{
                font: inherit;
                font-size: 2.5em;
                font-weight: 700;
                line-height: 1.5;
                color: $dv5-color1;
                display: flex;
                align-items: center!important;
                img{
                    font: inherit;
                    height: 1em;
                    width: auto;
                }
                .img-top{
                    display: none!important;
                }
            }
            .dv5-header-subtitle{
                font: inherit;
                font-size: 1.5em;
                font-weight: 700;
                line-height: 1.5;
                color: $dv5-color3;
                display: flex;
                align-items: baseline;
                img{
                    font: inherit;
                    height: 1.66em;
                    width: auto;
                    margin-left: 5px;
                }
                span{
                    color: $dv5-color2!important;
                }
                .img-end{
                    display: block!important;
                }
            }
        }
        .dv5-header-button-content {
            display: inline-flex;
            justify-content: flex-end;
            width: auto;
            gap: 3px;
            font: inherit;

            .wpp-group {
                width: auto;
                height: 40px;
                max-width: 350px;
                border-radius: 6px;

                display: inline-flex;
                justify-content: center;
                align-items: center;

                padding: 0 .7rem 0 .5rem;

                background-color: #128c7e;
                color: white;
                font-weight: 600;

                img {
                    width: 25px;
                    height: auto;
                }
            }
        }
    }

    @media (max-width: 1080px) {
        .dv5-header{
            flex-direction: column;
            align-items: flex-start;
            justify-content: center;
            .dv5-header-title-content {
                .dv5-header-title{
                    .img-top{
                        display: block!important;
                    }
                }
                .dv5-header-subtitle{
                    .img-end{
                        display: none!important;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// resources/office/js/components/dashboard-v5/header.vue